import { fontSize, minBreakpoints, theme } from '@noths/polaris-client-ribbons-base';
import { inset, mediaQuery, shadowUp } from '@noths/polaris-client-styles';
import { css } from 'styled-components';

const { fonts, text } = theme;

export const errorBoundary = css`
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;

  ${mediaQuery(
    { min: minBreakpoints.M },
    css`
      ${shadowUp};
    `,
  )};
`;

export const heading = css`
  margin: ${inset(10, 60)};
  font-weight: 600;
  text-align: center;
  font-family: ${fonts.PRIMARY_REGULAR.family};
  ${fontSize(text.HEADING.XL)}
`;
